export const FILE_TYPES = {
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  SVG: 'image/svg+xml',
  CSV: 'text/csv',
  MP3: 'audio/mpeg',
  MP3_ALT: 'audio/mp3',
  M4A: 'audio/mp4',
  M4A_ALT: 'audio/x-m4a',
  AAC: 'audio/aac',
  WAV: 'audio/wav',
  WAV_ALT: 'audio/x-wav',
  OGG: 'audio/ogg',
  WEBM_AUDIO: 'audio/webm',
};

export const IMAGE_FILE_TYPES = [
  FILE_TYPES.JPEG,
  FILE_TYPES.PNG,
  FILE_TYPES.JPG,
  FILE_TYPES.SVG,
];

// The sidebar paints --logo-background behind the logo, so the desktop slot
// rejects JPG: it cannot carry transparency and would ship an opaque box.
export const BRAND_LOGO_FILE_TYPES = [FILE_TYPES.PNG, FILE_TYPES.SVG];

// Formats <audio> can actually play. Browsers disagree on what to report for
// the same file — .mp3 comes through as audio/mpeg or audio/mp3, .m4a as
// audio/mp4 or audio/x-m4a — so the aliases are listed rather than trusted.
export const AUDIO_FILE_TYPES = [
  FILE_TYPES.MP3,
  FILE_TYPES.MP3_ALT,
  FILE_TYPES.M4A,
  FILE_TYPES.M4A_ALT,
  FILE_TYPES.AAC,
  FILE_TYPES.WAV,
  FILE_TYPES.WAV_ALT,
  FILE_TYPES.OGG,
  FILE_TYPES.WEBM_AUDIO,
];
